
<div class="section">
  <div class="title-info" [class.no-border]='isHeader'>
    <h1 *ngIf="title" class="title" [class.big-title]='isHeader'>{{title}}</h1>
    
    <i *ngIf="icon" class="ic-info"></i>
  </div>
  <p *ngIf="description" class="description">{{description}}</p>
</div>
